const rules = {
  agree: {
    getMessage: (field) => {
      const msg = `Please agree to the ${field}`;
      return msg;
    },
    validate(value) {
      const valid = value === true || value === 'true';
      return {
        valid,
      };
    },
  },
};

export default (Validator) => {
  Object.keys(rules).forEach(rule => Validator.extend(rule, rules[rule]));
};
